import { render, staticRenderFns } from "./Oldmanmap.vue?vue&type=template&id=18c8ef37&scoped=true"
import script from "./Oldmanmap.vue?vue&type=script&lang=js"
export * from "./Oldmanmap.vue?vue&type=script&lang=js"
import style0 from "./Oldmanmap.vue?vue&type=style&index=0&id=18c8ef37&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18c8ef37",
  null
  
)

export default component.exports